import { useAuth } from '@/contexts/AuthContext';
import { useTenantView } from '@/contexts/TenantViewContext';

/**
 * Returns true when the current user is an admin who is NOT in tenant view.
 * Use this instead of `isAdmin()` whenever the intent is "acting as admin right now"
 * (i.e., should NOT apply when admin has switched to tenant view via ViewToggle).
 */
export const useActingAsAdmin = (): boolean => {
  const { isAdmin } = useAuth();
  const { inTenantView } = useTenantView();
  return isAdmin() && !inTenantView;
};
